import { render } from "./detail1Page.vue?vue&type=template&id=5dd750e2"
import script from "./detail1Page.vue?vue&type=script&lang=js"
export * from "./detail1Page.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__